<div class="flex justify-between py-6 border-b border-neutral-base">
  <span class="text-[18px] font-black">
    <i
      [class.pi]="true"
      [class.pi-file-check]="true"
      style="font-size: 2rem"></i>
    REVISIÓN DE PROYECTO
  </span>

  <div
    *ngIf="!isChief()"
    class="flex gap-3">
    <button
      type="button"
      class="text-[16px] text-primary-base underline bg-transparent border-none pr-2 font-semibold cursor-pointer"
      (click)="backPage()">
      Cancelar
    </button>
    <app-buttons
      [label]="'Sugerir Subsanación'"
      [classes]="'text-primary-base border border-primary-base'"
      [disabled]="readonlyReview"
      [attr.title]="readonlyReview ? 'La revisión ya fue registrada y no puede modificarse.' : null"
      [attr.aria-label]="readonlyReview ? 'La revisión ya fue registrada y no puede modificarse.' : null"
      [attr.tabindex]="readonlyReview ? 0 : null"
      (click)="confirm('CORRECTION')" />

    <app-buttons
      [label]="'Aprobar'"
      [classes]="'bg-primary-base text-primary-light'"
      [disabled]="readonlyReview"
      [attr.title]="readonlyReview ? 'La revisión ya fue registrada y no puede modificarse.' : null"
      [attr.aria-label]="readonlyReview ? 'La revisión ya fue registrada y no puede modificarse.' : null"
      [attr.tabindex]="readonlyReview ? 0 : null"
      (click)="confirm('APPROVED')" />
  </div>
  <div
    *ngIf="isChief()"
    class="flex gap-3">
    <app-buttons
      [label]="'Cancelar'"
      (click)="backPage()" />
    <app-buttons
      [label]="'Subsanar'"
      [classes]="'text-primary-base border border-primary-base'"
      [disabled]="readonlyReview"
      [attr.title]="readonlyReview ? 'La revisión ya fue registrada y no puede modificarse.' : null"
      [attr.aria-label]="readonlyReview ? 'La revisión ya fue registrada y no puede modificarse.' : null"
      [attr.tabindex]="readonlyReview ? 0 : null"
      (click)="confirm('CORRECTION')" />
    <div
      [attr.title]="
        hasMarkedFields() ? 'Para enviar a aprobación no deben quedar campos seleccionados para subsanación.' : null
      ">
      <app-buttons
        [label]="'Enviar a aprobación'"
        [classes]="'bg-primary-base text-primary-light'"
        [disabled]="readonlyReview || hasMarkedFields()"
        (click)="confirm('APPROVED')" />
    </div>
  </div>
</div>
<p-confirmDialog></p-confirmDialog>
<div class="flex flex-col gap-10">
  <div
    *ngIf="project"
    class="flex flex-col gap-2 mt-8">
    <div class="flex flex-col gap-2 py-4">
      <span class="text-[24px] font-bold mb-2">Revisa todos los campos del proyecto</span>
      <div
        *ngIf="readonlyReview"
        class="flex flex-col gap-6 text-[16px] leading-7">
        <span>
          Estás consultando una revisión previamente registrada. Desde esta vista es posible revisar los campos
          observados durante el proceso de revisión, así como consultar el histórico completo de revisiones realizadas
          por los distintos perfiles revisores.
        </span>

        <span>
          El histórico muestra los comentarios asociados a cada revisión y el estado propuesto para el proyecto en cada
          fase del proceso de validación. La información se presenta en modo solo lectura y no permite realizar
          modificaciones sobre la revisión enviada.
        </span>
      </div>
      <div
        *ngIf="!readonlyReview && !isChief()"
        class="flex flex-col gap-6 text-[16px]">
        <span>
          Añade los comentarios que consideres necesarios sobre la revisión. Al finalizar, se aplicará una de estas dos
          opciones según tu acción:
        </span>
        <div class="flex flex-col gap-4 pl-4 text-neutral-dark">
          <span>
            •
            <strong class="text-black text-[16px]">Finalizar revisión:</strong>
            el proyecto pasará a la siguiente fase, donde será evaluado por el grupo de revisores correspondiente.
          </span>
          <span>
            •
            <strong class="text-black text-[16px] font-semibold">Subsanar proyecto:</strong>
            el solicitante deberá revisar y corregir los campos indicados en tus comentarios antes de volver a solicitar
            el alta.
          </span>
        </div>
        <span class="text-neutral-dark text-[16px]">
          Ten en cuenta que los comentarios que escribas podrán ser visibles para otros revisores a medida que avance el
          flujo de revisión.
        </span>
      </div>
      <div
        *ngIf="!readonlyReview && isChief()"
        class="text-[16px]">
        Selecciona los campos que consideres incorrectos o bien necesitan revisión por parte de la persona que solicita
        el alta del proyecto. Es posible que veas campos ya seleccionados, esto se debe a que han sido marcados como
        incorrectos por parte del equipo de revisores. Para poder enviar a aprobación el proyecto no puede haber ningun
        campo marcado.
      </div>
    </div>
    <div
      *ngIf="!readonlyReview"
      class="flex flex-col gap-2">
      <span class="text-xl font-bold mt-4">Comentario sobre la revisión</span>
      <span class="text-[16px] font-normal">Comentarios</span>
      <span class="text-[16px] text-neutral-dark">
        Los comentarios que escribas en este apartado se mostrarán en el turno de revisión de cada revisor.
      </span>
      <textarea
        class="w-full min-h-[160px] border border-neutral-base rounded p-3"
        [disabled]="readonlyReview"
        [(ngModel)]="reviewComment"></textarea>
    </div>
    <div
      class="flex flex-col mt-8"
      *ngIf="(readonlyReview || !isSupportGroup()) && reviewComments?.length">
      <app-review-comments-block [comments]="reviewComments"></app-review-comments-block>
    </div>
    <div class="flex flex-col gap-10 mt-10">
      <app-project-identification-data
        [project]="project"
        [reviewMode]="true"
        [readonlyReview]="readonlyReview"
        [showPreviousReviewIndicators]="shouldShowPreviousReviewIndicators()" />
      <app-project-functional-data
        [project]="project"
        [reviewMode]="true"
        [readonlyReview]="readonlyReview"
        [showPreviousReviewIndicators]="shouldShowPreviousReviewIndicators()" />
      <app-project-economic-data
        [project]="project"
        [reviewMode]="true"
        [readonlyReview]="readonlyReview"
        [showPreviousReviewIndicators]="shouldShowPreviousReviewIndicators()" />
      <app-project-input-data
        [project]="project"
        [reviewMode]="true"
        [readonlyReview]="readonlyReview"
        [showPreviousReviewIndicators]="shouldShowPreviousReviewIndicators()" />
      <app-project-risk-data
        [project]="project"
        [reviewMode]="true"
        [readonlyReview]="readonlyReview"
        [showPreviousReviewIndicators]="shouldShowPreviousReviewIndicators()" />
    </div>
  </div>
</div>
